import { useForceUpdate } from 'hooks/useForceUpdate';
import { resizeToWidthHeight } from 'lib/riskbase';
import React from 'react';
import { LayoutChangeEvent, View } from 'react-native';
import { Image } from 'expo-image';

type Props = {
  signature: string;
};

const BaseWidth = 500;
const BaseHeight = BaseWidth / 2.5; // 200;

export const SignatureViewer: React.FC<Props> = ({ signature }) => {
  const forceUpdate = useForceUpdate();
  const wh = React.useRef<{
    width: number;
    height: number;
  }>({
    width: 0,
    height: 0,
  });

  // Get a "good" width and height which fits inside screen
  const handleLayout = React.useCallback(
    (event: LayoutChangeEvent) => {
      const { width, height } = resizeToWidthHeight({
        width: BaseWidth,
        height: BaseHeight,
        outgoingWidth: event.nativeEvent.layout.width || BaseWidth,
        outgoingHeight: BaseHeight,
        allowScaleUp: false,
      });
      wh.current = {
        width: Math.round(width),
        height: Math.round(height),
      };
      forceUpdate();
    },
    [forceUpdate],
  );

  return (
    <View
      onLayout={handleLayout}
      style={{
        flex: 1,
        backgroundColor: 'white',
        alignItems: 'center',
      }}
    >
      <Image
        style={{
          width: wh.current.width,
          height: wh.current.height,
        }}
        source={{ uri: signature }}
      />
    </View>
  );
};
